import {
  listVariants,
  rowVariants,
} from 'components/containers/CollapsableMenu/components/CollapsableFolder/variants';
import { MenuRow } from 'components/containers/CollapsableMenu/index';
import Typography from 'components/generics/texts/Typography';
import { motion } from 'framer-motion';
import Caret from 'public/assets/icons/caret_right.svg';
import Folder from 'public/assets/icons/folder.svg';
import { useState } from 'react';
import classes from './index.module.scss';

const CollapsableFolder = ({
  items,
  title,
  subtitle,
  rightText,
  withItemsCount = true,
}: {
  items: MenuRow[];
  title: string;
  subtitle?: string;
  rightText?: string;
  withItemsCount?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.nav
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
      className={classes.container}
    >
      <motion.button
        className={classes.button}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={classes.titleContainer}>
          <motion.div
            variants={{
              open: { rotate: 90 },
              closed: { rotate: 0 },
            }}
            transition={{ duration: 0.2 }}
            className={classes.caretContainer}
          >
            <Caret className={classes.caret} />
          </motion.div>
          <Folder className={classes.folderIcon} />
          <div className={classes.textContainer}>
            <div>
              <div className={classes.titleContainer}>
                <Typography>{title}</Typography>
                {withItemsCount && (
                  <Typography className={classes.itemsCount}>
                    {items.length}
                  </Typography>
                )}
              </div>
              {subtitle && (
                <Typography className={classes.subtitle}>{subtitle}</Typography>
              )}
            </div>
            {rightText && (
              <Typography className={classes.rightText}>{rightText}</Typography>
            )}
          </div>
        </div>
      </motion.button>
      <motion.ul
        variants={listVariants}
        className={classes.itemsContainer}
        style={{
          pointerEvents: isOpen ? 'auto' : 'none',
        }}
      >
        {items.map((item, index) => (
          <motion.li
            key={index.toString()}
            className={classes.item}
            variants={rowVariants}
          >
            <>{item.row}</>
          </motion.li>
        ))}
      </motion.ul>
    </motion.nav>
  );
};

export default CollapsableFolder;
